module.exports = __webpack_public_path__ + "static/media/telesystem.615681cc.png";